import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'

import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'
import { sanitize } from 'utils/text'

const KMDisclaimer = (props?: {
  className?: string
  topicQueryName?: string
}) => {
  const { data } = useGetKeyPairValue<{
    content: string
    topicIds: Array<string | number>
  }>(MILKvKeys.KMDisclaimer, true, { staleTime: Infinity })
  const { query } = useRouter()
  const shouldShowDisclaimer =
    data?.data?.topicIds?.findIndex(
      (id) => String(id) === String(query[props.topicQueryName || 'topik'])
    ) > -1

  if (!shouldShowDisclaimer) return null
  return (
    <Text
      className={clsx(props.className)}
      variant="helper"
      color="subdued"
      dangerouslySetInnerHTML={{ __html: sanitize(data?.data?.content) }}
    />
  )
}

export default KMDisclaimer
